export default __webpack_public_path__ + "assets/ico_info_highlight-10a01005.svg";